import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { getReportConfig } from 'features/liveReport/asyncThunks'

const useRetrieveReportConfig = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getReportConfig())
  }, [dispatch])
}

export default useRetrieveReportConfig
